export class Result<T> {
    private constructor(
        readonly error?: string,
        readonly isLoading: boolean = false,
        readonly data?: T,
        readonly errorDetails?: Record<string, any>,
    ) {}

    get isSuccess(): boolean {
        return this.data !== undefined;
    }

    hasData(): this is Result<T> & { data: T } {
        return this.data !== undefined;
    }

    get hasError(): boolean {
        return this.error !== undefined;
    }

    static loading<T>(): Result<T> {
        return new Result<T>(undefined, true);
    }

    static success<T>(data: T): Result<T> {
        return new Result<T>(undefined, false, data);
    }

    static failure<T>(error: string, errorDetails?: Record<string, any>): Result<T> {
        return new Result<T>(error, false, undefined, errorDetails);
    }

    async when<R>({
        loading,
        success,
        failure,
    }: {
        loading?: () => Promise<R> | R;
        success?: (value: T) => Promise<R> | R;
        failure?: (error: string) => Promise<R> | R;
    }): Promise<R | undefined> {
        if (this.isLoading && loading) {
            return await loading();
        } else if (this.data !== undefined && success) {
            return await success(this.data);
        } else if (this.error !== undefined && failure) {
            return await failure(this.error);
        }
        return undefined;
    }
}